import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";
import { useAddFreeUnloadingMutation } from "store/services/shipmentUnLoadingApi";
import FreeUnLoadingForm from "./ShipmentUnLoadingComponents/FreeUnLoadingForm";

const FreeUnloadingCreateScreen = () => {
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Free Unloading", path: "/app/crm/shipment-unLoading/list" },
        { title: "New Free Unloading" },
    ];

    const [createFreeUnloading, { isLoading: creatingFreeUnloading }] =
        useAddFreeUnloadingMutation();

    // methods
    const handleAddFreeUnloading = async (data) => {
        try {
            const response = await createFreeUnloading(data).unwrap();
            const unloadingId = response.unloading._id;
            toast.success("Free Unloading and Delivery Created!");
            navigate(`/app/crm/shipment-unloading/${unloadingId}/detail`);
        } catch (error) {
            toast.error(
                error?.data?.message ?? error.message ?? "Could Not Create Free Unloading!"
            );
        }
    };

    useAppMeta("New Free Unloading");

    return (
        <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingFreeUnloading}>
            <BreadcrumbLayout.Paper>
                <FreeUnLoadingForm isBusy={creatingFreeUnloading} onSubmit={handleAddFreeUnloading} />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default FreeUnloadingCreateScreen;